export default __webpack_public_path__ + "static/media/boatEventIcon.24c2c9cd.png";